// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file accounts/get_partial_account.proto (package protos.accounts, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { WorkFunction } from "../general/work_function_pb";
import { file_general_work_function } from "../general/work_function_pb";
import type { WorkDepartment } from "../general/work_department_pb";
import { file_general_work_department } from "../general/work_department_pb";
import type { WorkLocation } from "../general/work_location_pb";
import { file_general_work_location } from "../general/work_location_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file accounts/get_partial_account.proto.
 */
export const file_accounts_get_partial_account: GenFile = /*@__PURE__*/
  fileDesc("CiJhY2NvdW50cy9nZXRfcGFydGlhbF9hY2NvdW50LnByb3RvEg9wcm90b3MuYWNjb3VudHMijgMKGEdldFBhcnRpYWxBY2NvdW50UmVxdWVzdBJACgZwYXJhbXMYASABKAsyMC5wcm90b3MuYWNjb3VudHMuR2V0UGFydGlhbEFjY291bnRSZXF1ZXN0LlBhcmFtcxJECghpbmNsdWRlcxgCIAEoCzIyLnByb3Rvcy5hY2NvdW50cy5HZXRQYXJ0aWFsQWNjb3VudFJlcXVlc3QuSW5jbHVkZXMaHAoGUGFyYW1zEhIKCmFjY291bnRfaWQYASABKAkaywEKCEluY2x1ZGVzEgwKBG5hbWUYASABKAgSDwoHcGZwX3VybBgCIAEoCBIaChJtYWluX3dvcmtfZnVuY3Rpb24YAyABKAgSHAoUb3RoZXJfd29ya19mdW5jdGlvbnMYBCABKAgSGgoSbWFpbl93b3JrX2xvY2F0aW9uGAUgASgIEhUKDWlzX2Nvbm5lY3Rpb24YBiABKAgSGQoRdW5pb25fbWVtYmVyc2hpcHMYByABKAgSGAoQaXNfYmxvY2tlZF9ieV9tZRgIIAEoCCL8BgoZR2V0UGFydGlhbEFjY291bnRSZXNwb25zZRJBCgZyZXN1bHQYASABKAsyMS5wcm90b3MuYWNjb3VudHMuR2V0UGFydGlhbEFjY291bnRSZXNwb25zZS5SZXN1bHQamwYKBlJlc3VsdBISCgphY2NvdW50X2lkGAEgASgJEgwKBG5hbWUYAiABKAkSDwoHcGZwX3VybBgDIAEoCRJeChJtYWluX3dvcmtfZnVuY3Rpb24YBCABKAsyQi5wcm90b3MuYWNjb3VudHMuR2V0UGFydGlhbEFjY291bnRSZXNwb25zZS5SZXN1bHQuV29ya0Z1bmN0aW9uRGF0YRJgChRvdGhlcl93b3JrX2Z1bmN0aW9ucxgFIAMoCzJCLnByb3Rvcy5hY2NvdW50cy5HZXRQYXJ0aWFsQWNjb3VudFJlc3BvbnNlLlJlc3VsdC5Xb3JrRnVuY3Rpb25EYXRhEjgKEm1haW5fd29ya19sb2NhdGlvbhgGIAEoDjIcLnByb3Rvcy5nZW5lcmFsLldvcmtMb2NhdGlvbhIVCg1pc19jb25uZWN0aW9uGAcgASgIElwKEXVuaW9uX21lbWJlcnNoaXBzGAggAygLMkEucHJvdG9zLmFjY291bnRzLkdldFBhcnRpYWxBY2NvdW50UmVzcG9uc2UuUmVzdWx0LlVuaW9uTWVtYmVyc2hpcBIYChBpc19ibG9ja2VkX2J5X21lGAkgASgIGnYKEFdvcmtGdW5jdGlvbkRhdGESLgoIZnVuY3Rpb24YASABKA4yHC5wcm90b3MuZ2VuZXJhbC5Xb3JrRnVuY3Rpb24SMgoKZGVwYXJ0bWVudBgCIAEoDjIeLnByb3Rvcy5nZW5lcmFsLldvcmtEZXBhcnRtZW50GtoBCg9Vbmlvbk1lbWJlcnNoaXASEAoIdW5pb25faWQYASABKAkScAoTY2VydGlmaWVkX2Z1bmN0aW9ucxgCIAMoCzJTLnByb3Rvcy5hY2NvdW50cy5HZXRQYXJ0aWFsQWNjb3VudFJlc3BvbnNlLlJlc3VsdC5Vbmlvbk1lbWJlcnNoaXAuQ2VydGlmaWVkRnVuY3Rpb24aQwoRQ2VydGlmaWVkRnVuY3Rpb24SLgoIZnVuY3Rpb24YASABKA4yHC5wcm90b3MuZ2VuZXJhbC5Xb3JrRnVuY3Rpb25iBnByb3RvMw", [file_general_work_function, file_general_work_department, file_general_work_location]);

/**
 * @generated from message protos.accounts.GetPartialAccountRequest
 */
export type GetPartialAccountRequest = Message<"protos.accounts.GetPartialAccountRequest"> & {
  /**
   * @generated from field: protos.accounts.GetPartialAccountRequest.Params params = 1;
   */
  params?: GetPartialAccountRequest_Params | undefined;

  /**
   * @generated from field: protos.accounts.GetPartialAccountRequest.Includes includes = 2;
   */
  includes?: GetPartialAccountRequest_Includes | undefined;
};

/**
 * Describes the message protos.accounts.GetPartialAccountRequest.
 * Use `create(GetPartialAccountRequestSchema)` to create a new message.
 */
export const GetPartialAccountRequestSchema: GenMessage<GetPartialAccountRequest> = /*@__PURE__*/
  messageDesc(file_accounts_get_partial_account, 0);

/**
 * @generated from message protos.accounts.GetPartialAccountRequest.Params
 */
export type GetPartialAccountRequest_Params = Message<"protos.accounts.GetPartialAccountRequest.Params"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;
};

/**
 * Describes the message protos.accounts.GetPartialAccountRequest.Params.
 * Use `create(GetPartialAccountRequest_ParamsSchema)` to create a new message.
 */
export const GetPartialAccountRequest_ParamsSchema: GenMessage<GetPartialAccountRequest_Params> = /*@__PURE__*/
  messageDesc(file_accounts_get_partial_account, 0, 0);

/**
 * @generated from message protos.accounts.GetPartialAccountRequest.Includes
 */
export type GetPartialAccountRequest_Includes = Message<"protos.accounts.GetPartialAccountRequest.Includes"> & {
  /**
   * @generated from field: bool name = 1;
   */
  name: boolean;

  /**
   * @generated from field: bool pfp_url = 2;
   */
  pfpUrl: boolean;

  /**
   * @generated from field: bool main_work_function = 3;
   */
  mainWorkFunction: boolean;

  /**
   * @generated from field: bool other_work_functions = 4;
   */
  otherWorkFunctions: boolean;

  /**
   * @generated from field: bool main_work_location = 5;
   */
  mainWorkLocation: boolean;

  /**
   * @generated from field: bool is_connection = 6;
   */
  isConnection: boolean;

  /**
   * @generated from field: bool union_memberships = 7;
   */
  unionMemberships: boolean;

  /**
   * @generated from field: bool is_blocked_by_me = 8;
   */
  isBlockedByMe: boolean;
};

/**
 * Describes the message protos.accounts.GetPartialAccountRequest.Includes.
 * Use `create(GetPartialAccountRequest_IncludesSchema)` to create a new message.
 */
export const GetPartialAccountRequest_IncludesSchema: GenMessage<GetPartialAccountRequest_Includes> = /*@__PURE__*/
  messageDesc(file_accounts_get_partial_account, 0, 1);

/**
 * @generated from message protos.accounts.GetPartialAccountResponse
 */
export type GetPartialAccountResponse = Message<"protos.accounts.GetPartialAccountResponse"> & {
  /**
   * @generated from field: protos.accounts.GetPartialAccountResponse.Result result = 1;
   */
  result?: GetPartialAccountResponse_Result | undefined;
};

/**
 * Describes the message protos.accounts.GetPartialAccountResponse.
 * Use `create(GetPartialAccountResponseSchema)` to create a new message.
 */
export const GetPartialAccountResponseSchema: GenMessage<GetPartialAccountResponse> = /*@__PURE__*/
  messageDesc(file_accounts_get_partial_account, 1);

/**
 * @generated from message protos.accounts.GetPartialAccountResponse.Result
 */
export type GetPartialAccountResponse_Result = Message<"protos.accounts.GetPartialAccountResponse.Result"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string pfp_url = 3;
   */
  pfpUrl: string;

  /**
   * @generated from field: protos.accounts.GetPartialAccountResponse.Result.WorkFunctionData main_work_function = 4;
   */
  mainWorkFunction?: GetPartialAccountResponse_Result_WorkFunctionData | undefined;

  /**
   * @generated from field: repeated protos.accounts.GetPartialAccountResponse.Result.WorkFunctionData other_work_functions = 5;
   */
  otherWorkFunctions: GetPartialAccountResponse_Result_WorkFunctionData[];

  /**
   * @generated from field: protos.general.WorkLocation main_work_location = 6;
   */
  mainWorkLocation: WorkLocation;

  /**
   * @generated from field: bool is_connection = 7;
   */
  isConnection: boolean;

  /**
   * @generated from field: repeated protos.accounts.GetPartialAccountResponse.Result.UnionMembership union_memberships = 8;
   */
  unionMemberships: GetPartialAccountResponse_Result_UnionMembership[];

  /**
   * @generated from field: bool is_blocked_by_me = 9;
   */
  isBlockedByMe: boolean;
};

/**
 * Describes the message protos.accounts.GetPartialAccountResponse.Result.
 * Use `create(GetPartialAccountResponse_ResultSchema)` to create a new message.
 */
export const GetPartialAccountResponse_ResultSchema: GenMessage<GetPartialAccountResponse_Result> = /*@__PURE__*/
  messageDesc(file_accounts_get_partial_account, 1, 0);

/**
 * @generated from message protos.accounts.GetPartialAccountResponse.Result.WorkFunctionData
 */
export type GetPartialAccountResponse_Result_WorkFunctionData = Message<"protos.accounts.GetPartialAccountResponse.Result.WorkFunctionData"> & {
  /**
   * @generated from field: protos.general.WorkFunction function = 1;
   */
  function: WorkFunction;

  /**
   * @generated from field: protos.general.WorkDepartment department = 2;
   */
  department: WorkDepartment;
};

/**
 * Describes the message protos.accounts.GetPartialAccountResponse.Result.WorkFunctionData.
 * Use `create(GetPartialAccountResponse_Result_WorkFunctionDataSchema)` to create a new message.
 */
export const GetPartialAccountResponse_Result_WorkFunctionDataSchema: GenMessage<GetPartialAccountResponse_Result_WorkFunctionData> = /*@__PURE__*/
  messageDesc(file_accounts_get_partial_account, 1, 0, 0);

/**
 * @generated from message protos.accounts.GetPartialAccountResponse.Result.UnionMembership
 */
export type GetPartialAccountResponse_Result_UnionMembership = Message<"protos.accounts.GetPartialAccountResponse.Result.UnionMembership"> & {
  /**
   * @generated from field: string union_id = 1;
   */
  unionId: string;

  /**
   * @generated from field: repeated protos.accounts.GetPartialAccountResponse.Result.UnionMembership.CertifiedFunction certified_functions = 2;
   */
  certifiedFunctions: GetPartialAccountResponse_Result_UnionMembership_CertifiedFunction[];
};

/**
 * Describes the message protos.accounts.GetPartialAccountResponse.Result.UnionMembership.
 * Use `create(GetPartialAccountResponse_Result_UnionMembershipSchema)` to create a new message.
 */
export const GetPartialAccountResponse_Result_UnionMembershipSchema: GenMessage<GetPartialAccountResponse_Result_UnionMembership> = /*@__PURE__*/
  messageDesc(file_accounts_get_partial_account, 1, 0, 1);

/**
 * @generated from message protos.accounts.GetPartialAccountResponse.Result.UnionMembership.CertifiedFunction
 */
export type GetPartialAccountResponse_Result_UnionMembership_CertifiedFunction = Message<"protos.accounts.GetPartialAccountResponse.Result.UnionMembership.CertifiedFunction"> & {
  /**
   * @generated from field: protos.general.WorkFunction function = 1;
   */
  function: WorkFunction;
};

/**
 * Describes the message protos.accounts.GetPartialAccountResponse.Result.UnionMembership.CertifiedFunction.
 * Use `create(GetPartialAccountResponse_Result_UnionMembership_CertifiedFunctionSchema)` to create a new message.
 */
export const GetPartialAccountResponse_Result_UnionMembership_CertifiedFunctionSchema: GenMessage<GetPartialAccountResponse_Result_UnionMembership_CertifiedFunction> = /*@__PURE__*/
  messageDesc(file_accounts_get_partial_account, 1, 0, 1, 0);

